<template>
  <section class="light-footer">
    <h2 class="light-footer__header">Have Questions?</h2>
    <p class="light-footer__text">Our team of friendly representatives is standing by during business hours to make sure your dumpster rental process goes smoothly from start to finish.</p>
    <a class="light-footer__phone-detail" :href="`tel:+${phoneNumber}`">
      <img :src="phoneIcon" />
      {{phoneNumber}}
    </a>
  </section>
</template>

<script>
import config from '@/config'
const { cdn, phoneNumber } = config

export default {
  name: 'LightFooter',
  data () {
    return {
      phoneIcon: `${cdn}footer-phone-icon.svg`,
      phoneNumber
    }
  }
}
</script>
